// extracted by mini-css-extract-plugin
export default {"BLSpinner":"spinner__BLSpinner__EZJKO","BLSpinnerSm":"spinner__BLSpinnerSm__fgGYU","BLSpinnerLg":"spinner__BLSpinnerLg__IYJWn"};